<template>
  <div>
    <dl
      class="padding-top-md padding-bottom-xl padding-left-5xl padding-right-2xl margin-0 display-flex flex-row flex-items-center flex-wrap"
      style="
        gap: var(--spacing-md);
        border-top: var(--border-width-sm) solid var(--fa-dk-navy);
        --link-color: var(--fa-blue);
        --link-hover-color: var(--white);
        --list-line-height: 1.2;
      "
    >
      <dt
        class="margin-y-0 margin-right-0 size-sm"
        style="font-weight: var(--font-weight-normal); margin-left: calc(var(--spacing-3xl) * -1)"
      >
        <font-awesome-icon
          :icon="$v6.solid.faCircleInfo"
          style="color: var(--fa-blue)"
          fixed-width
          size="lg"
        />
        <span class="sr-only margin-left-2xs">Learn about&hellip; </span>
      </dt>
      <dd
        v-for="link in allLinks"
        :key="link.label"
        class="margin-bottom-0 size-sm"
      >
        <site-link
          v-if="version === 5"
          :to="$docs.v5(link.path, { hash: link.hash })"
          @click.native="$posthog.capture(`icon:docs_${this.link.label}_link_click`, { version: '5' })"
        >
          {{ link.label }}
        </site-link>

        <site-link
          v-else
          :to="$docs(link.path, { hash: link.hash })"
          @click.native="$posthog.capture(`icon:docs_${this.link.label}_link_click`)"
        >
          {{ link.label }}
        </site-link>
      </dd>
    </dl>
  </div>
</template>

<script>
  import { allLearnAboutLinks } from 'app/views/icons/routing.js'
  import { EventTrackingMixin } from 'app/mixins'

  export default {
    name: 'IconCodeSnippetLinks',

    mixins: [EventTrackingMixin],

    props: {
      hasCustomStyling: {
        type: Boolean
      },
      links: {
        type: Array,
        default: () => []
      },
      selectedStyle: {
        type: String
      },
      version: {
        type: Number
      }
    },

    data() {
      return {}
    },

    computed: {
      allLinks() {
        const linkResults = allLearnAboutLinks({
          version: this.version,
          links: this.links,
          selectedStyle: this.selectedStyle,
          hasCustomStyling: this.hasCustomStyling
        })

        return linkResults
      }
    }
  }
</script>
